import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { ReSyncTransactionListing } from '../Pages/listing';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { exportReSyncTransactionSchemaObject } from '../exportReSyncSchema';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import TextField from '@material-ui/core/TextField';

const screenCode = 'RESYNCTRANSACTIONS'

export function TransactionsSyncFiltering(props) {

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [divisions, setDevisions] = useState([]);
    const [exportSyncFilteringData, setExportSyncFilteringData] = useState([]);
    const [errors, setErrors] = useState({});
    const schema = Joi.object(exportReSyncTransactionSchemaObject).options({ allowUnknown: true });

    const [exportReSyncTransactionFiltering, setExportReSyncTransactionFiltering] = useState({
        groupID: '0',
        operationEntityID: '0',
        divisionID: '0',
        fromDate: '',
        toDate: '',
        transactionTypeID: '0'
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Completed successfuly."
    });

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        getPermissions();

    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntityForDropDown()
        )
    }, [exportReSyncTransactionFiltering.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [exportReSyncTransactionFiltering.operationEntityID]);

    useEffect(() => {
        setExportSyncFilteringData([]);
    }, [exportReSyncTransactionFiltering]);

    useEffect(() => {
        if (exportReSyncTransactionFiltering.transactionTypeID == '4') {
            setExportReSyncTransactionFiltering({
                ...exportReSyncTransactionFiltering,
                divisionID: '0',
            });
        }
    }, [exportReSyncTransactionFiltering.transactionTypeID]);

    function handleGroupDropdown(target) {
        validateInputs(target);

        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            groupID: target.value,
            operationEntityID: '0',
            divisionID: '0',

        });
    }

    function handleOperationEntityDropdown(target) {
        validateInputs(target);

        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            operationEntityID: target.value,
            divisionID: '0',
        });
    }
    function handleTransactionType(target) {
        validateInputs(target);

        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            transactionTypeID: target.value,
        });
    }
    function handleCollectionPointDropdown(target) {
        validateInputs(target);

        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            divisionID: target.value,

        });
    }

    function handleFromDate(target) {
        validateInputs(target);

        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            fromDate: target.value,
        });
    }

    function handleToDate(target) {
        validateInputs(target);

        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            toDate: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, exportReSyncTransactionSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error);
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            divisionID: '0',
            fromDate: '',
            toDate: '',
            transactionTypeID: '0'
        });
        setExportSyncFilteringData([]);
        setErrors('');
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWRESYNCTRANSACTIONS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITRESYNCTRANSACTIONS');

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setExportReSyncTransactionFiltering({
            ...exportReSyncTransactionFiltering,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropdown(),
            getOperationEntityForDropDown()
        )
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntityForDropDown() {
        const operationEntity = await services.GetAllOperationEntityByGroupID(exportReSyncTransactionFiltering.groupID);
        setOperationEntity(operationEntity);
    }

    async function getDevisions() {
        const result = await services.getDivisions(exportReSyncTransactionFiltering.operationEntityID)
        setDevisions(result)
    }
    async function handleSearch(e) {
        if (e !== undefined) {
            const errorMessages = validate(schema, exportReSyncTransactionFiltering);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        const response = await services.getFilterExportTransactions(exportReSyncTransactionFiltering);
        setExportSyncFilteringData(response);
    }

    async function editCollectionFiltering(data) {
        var model = {
            date: data.date,
            transactionTypeID: exportReSyncTransactionFiltering.transactionTypeID,
            estateID: exportReSyncTransactionFiltering.operationEntityID,
            divisionID: data.collectionPointID,
        }
        trackPromise(
            (async () => {
                const response = await services.reSyncMethod(model);
                if (response.statusCode === "Error") {
                    setMessageModel({
                        hidden: false,
                        type: "Error",
                        disciption: response.message || "No records to display"
                    });
                    return;
                }

                if (response.statusCode === "Success") {
                    setMessageModel({
                        hidden: false,
                        type: "Success",
                        disciption: response.message || "Synced Successfully"
                    });
                    const response1 = await services.getFilterExportTransactions(exportReSyncTransactionFiltering);
                    setExportSyncFilteringData(response1);
                }
            })()
        );
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title="Transaction Resync "
                                // isButtonEnable={true}
                                // path="reSyncTransaction/addEdit"
                                // buttonText="Sync Transaction"
                                />
                            </div>
                            <hr />

                            <form disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={exportReSyncTransactionFiltering.groupID}
                                            onChange={(e) => handleGroupDropdown(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={exportReSyncTransactionFiltering.operationEntityID}
                                            onChange={(e) => handleOperationEntityDropdown(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="transactionTypeID">Transaction Type *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="transactionTypeID"
                                            id="transactionTypeID"
                                            name="transactionTypeID"
                                            value={exportReSyncTransactionFiltering.transactionTypeID}
                                            onChange={(e) => handleTransactionType(e.target)}
                                        >
                                            <MenuItem value="0">--Transaction Type--</MenuItem>
                                            <MenuItem value="1">Checkroll</MenuItem>
                                            <MenuItem value="2">Overtime</MenuItem>
                                            <MenuItem value="3">Outgrower</MenuItem>
                                            <MenuItem value="4">Bought Leaf</MenuItem>

                                        </Select>
                                        {errors["transactionTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["transactionTypeID"]}</FormHelperText>}
                                    </div>

                                </div>
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="divisionID">Division </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={exportReSyncTransactionFiltering.divisionID}
                                            onChange={(e) => handleCollectionPointDropdown(e.target)}
                                            disabled={!permissionList.isOperationEntityFilterEnabled || exportReSyncTransactionFiltering.transactionTypeID == '4'}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate"> From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDate(e.target)}
                                            value={exportReSyncTransactionFiltering.fromDate}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate"> To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDate(e.target)}
                                            value={exportReSyncTransactionFiltering.toDate}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>}

                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        onClick={(e) => handleSearch(e)}
                                        className="btn btn-primary"
                                        value="Search"
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                                <ReSyncTransactionListing fieldFilteringData={exportSyncFilteringData} handleClick={editCollectionFiltering} />

                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}